import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { LucideAngularModule, LucideIconData } from 'lucide-angular';
import { PaginationComponent } from '../pagination/pagination.component';
import { TableSkeletonComponent } from '../table-skeleton/table-skeleton.component';

/**
 * Shared loading/empty/header/pagination shell for admin data tables.
 * Row markup (`<tbody>` content) is supplied by the consumer via content projection,
 * since column structure and per-cell rendering differ per table.
 */
@Component({
  selector: 'app-data-table-shell',
  imports: [NgClass, TranslatePipe, LucideAngularModule, TableSkeletonComponent, PaginationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './data-table-shell.component.html',
})
export class DataTableShellComponent {
  readonly loading      = input(false);
  readonly loadingRows  = input(5);
  readonly loadingCols  = input(5);

  readonly isEmpty        = input(false);
  readonly emptyIcon      = input<LucideIconData | null>(null);
  readonly emptyTitle     = input('');
  readonly emptySubtitle  = input('');

  /** Translation keys for each header cell; an empty string renders a blank/narrow header (e.g. a trailing actions column). */
  readonly columnLabels = input<string[]>([]);
  readonly minWidthClass = input('');

  readonly showPagination = input(false);
  readonly currentPage    = input(1);
  readonly totalCount     = input(0);
  readonly pageSize       = input(10);
  readonly pageChange     = output<number>();
}
